import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappminutabody} from './bodyappminutabody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './withRouter'
class Bodyappminuta extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappminutabody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappminuta);